export default class {
  constructor(el) {
    this.dom = {
      el: el,
      body: document.body
    };

    this.previousScrollY = 0;
    this.currentScrollY = 0;
    this.isListening = false;
    this.isScheduled = false;
    this.state = {
      direction: null,
      deep: null
    };

    this.update = this.update.bind(this);
    this.requestUpdate = this.requestUpdate.bind(this);

    this.init();
  }

  init() {
    this.startListening();
    this.update();
  }

  // スクロール・リサイズ時だけ、次のフレームで 1 回更新する（毎フレームの常時実行をしない）
  startListening() {
    if (!this.isListening) {
      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate, { passive: true });
      this.isListening = true;
    }
  }

  stopListening() {
    if (this.isListening) {
      window.removeEventListener('scroll', this.requestUpdate);
      window.removeEventListener('resize', this.requestUpdate);
      this.isListening = false;
    }
  }

  requestUpdate() {
    if (this.isScheduled) return;
    this.isScheduled = true;
    window.requestAnimationFrame(() => {
      this.isScheduled = false;
      this.update();
    });
  }

  update() {
    this.currentScrollY = window.pageYOffset;

    // スクロール方向を検知
    this.detectScrollDirection();

    // 画面の高さ以上スクロールしたかを検知
    this.detectScrollDepth();

    this.previousScrollY = this.currentScrollY;
  }

  detectScrollDirection() {
    let direction = this.state.direction;
    if (this.currentScrollY > this.previousScrollY) {
      // 下にスクロール
      direction = 'down';
    } else if (this.currentScrollY < this.previousScrollY) {
      // 上にスクロール
      direction = 'up';
    }
    // 値が変わったときだけ属性を書き換える
    if (direction !== this.state.direction) {
      this.state.direction = direction;
      this.dom.body.setAttribute('data-scroll-direction', direction);
    }
  }

  detectScrollDepth() {
    const viewportHeight = window.innerHeight;
    // 画面の高さ以上スクロールしたか
    const deep = this.currentScrollY >= viewportHeight;

    // 値が変わったときだけ属性を書き換える
    if (deep !== this.state.deep) {
      this.state.deep = deep;
      if (deep) {
        this.dom.body.setAttribute('data-scroll-depth', 'deep');
      } else {
        this.dom.body.removeAttribute('data-scroll-depth');
      }
    }
  }

  destroy() {
    this.stopListening();
  }
}
